import i18next from 'i18next';

const TARGET_WIDTH = 4079;
const GAP = 36;
const SPEED = 1;

let pos = 0;
let textWidth = 0;
let animationId = null;

function getMarqueeLine() {
  return document.querySelector('.marquee-line');
}

export function buildMarquee() {
  const marqueeLine = getMarqueeLine();
  if (!marqueeLine) return;

  const key = marqueeLine.dataset.marqueeKey;
  if (!key) return;

  const text = i18next.t(key, {
    defaultValue: 'Безкоштовна діагностика при ремонті',
  });

  marqueeLine.innerHTML = `<span>${text}</span>`;

  const firstSpan = marqueeLine.querySelector('span');
  if (!firstSpan) return;

  textWidth = firstSpan.offsetWidth + GAP;

  if (!textWidth || textWidth <= GAP) {
    textWidth = 300;
  }

  const repeatCount = Math.ceil(TARGET_WIDTH / textWidth) + 2;

  let html = '';

  for (let i = 0; i < repeatCount; i += 1) {
    html += `<span>${text}</span>`;
  }

  marqueeLine.innerHTML = html;
  marqueeLine.style.transform = 'translateX(0px)';
  pos = 0;
}

function animateMarquee() {
  const marqueeLine = getMarqueeLine();
  if (!marqueeLine) return;

  pos -= SPEED;

  if (pos <= -textWidth) {
    pos = 0;
  }

  marqueeLine.style.transform = `translateX(${pos}px)`;
  animationId = requestAnimationFrame(animateMarquee);
}

export function startMarquee() {
  buildMarquee();

  if (animationId) {
    cancelAnimationFrame(animationId);
  }

  animateMarquee();
}

export function updateMarquee() {
  buildMarquee();
}